(function() {
    const archiveEl = document.querySelector('.jsTrainingArchive');
    let archiveGrid = null;
    let searchTimeout = null;
    let searchQuery = '';

    if (archiveEl) {
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        const teachingTypeFilterEl = archiveEl.querySelector('.jsTeachingTypeFilter');
        if (teachingTypeFilterEl) {
            const teachingTypeSelect = new SeSelect(teachingTypeFilterEl, 'teaching-type');
            teachingTypeSelect.setActiveOptions(activeTeachingTypes);

            teachingTypeSelect.addChangeEventListener(newOptions => {
                activeTeachingTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const typeFilterEl = archiveEl.querySelector('.jsTypeFilter');
        if (typeFilterEl) {
            const typeSelect = new SeSelect(typeFilterEl, 'education-type');
            typeSelect.setActiveOptions(activeTypes);

            typeSelect.addChangeEventListener(newOptions => {
                activeTypes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            const themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(newOptions => {
                activeThemes = Object.keys(newOptions);
                updateGrid();
            });
        }

        const regionFilterEl = archiveEl.querySelector('.jsRegionFilter');
        if (regionFilterEl) {
            const regionSelect = new SeSelect(regionFilterEl, 'region');
            regionSelect.setActiveOptions(activeRegions);

            regionSelect.addChangeEventListener(newOptions => {
                activeRegions = Object.keys(newOptions);
                updateGrid();
            });
        }

        const searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            const searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        const url = new Url;

        if (searchQuery) url.query.search = searchQuery;
        else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(_ => updateGrid(), 500);
    }

    function updateGrid() {
        const params = {
            action: 'get_trainers_grid_html',
            activeTeachingTypes: activeTeachingTypes,
            activeTypes: activeTypes,
            activeThemes: activeThemes,
            activeRegions: activeRegions,
            searchQuery: searchQuery
        };

        se_postRequest(se_ajax.ajaxurl, params, response => {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            }
            else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }

        }, _ => {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();
